import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ApError } from '@ap/error';

import content from './error.content.json';
import { ErrorContext, hasAction } from './error.model';

/**
 * @module ErrorModule
 * @ngdoc component
 * @name ErrorComponent
 */
@Component({
    selector: 'tokens-browser-error',
    templateUrl: 'error.component.html',
    standalone: false
})
export class ErrorComponent implements OnInit {
    @Input()
    public apError: ApError;

    @Output()
    public action: EventEmitter<ErrorContext> = new EventEmitter();

    public constructor(private readonly contentService: ApContentService) {}

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
    }

    public performAction(context: string): void {
        this.action.emit(context as ErrorContext);
    }

    public hasAction(context: string): boolean {
        return hasAction.get(context as ErrorContext);
    }
}
